<template>
	<div id="master">
		<menudash v-if="loadingInformation"></menudash>
		<router-view v-if="loadingInformation" tabindex="1"></router-view>
	</div>
</template>

<script>

import MenuDash from '@/components/dashboard/Menu'

export default {
	name: 'dashboard',

	data () {
		return {
			logado: false,
			loadingInformation: false
		}
	},

	created(){

		let token = this.$cookie.get('token');

		if(!token){
			this.$helper.pushRouteTo({ name: 'Login' });
		}else{
			this.logado = true;
		}

	},

	beforeMount(){

		// Busca as informações sobre o merchant selecionado/logado
		var data = new FormData();
		data.append("class", 	"Overview");
		data.append("token", 	this.$cookie.get('token'));
		data.append("username", this.$cookie.get('username'));
		data.append("method", 	"getInfoMerchant");
		data.append("xpp", 		this.$cookie.get('xpp'));

		this.$helper.axios().post('', data)
			.then(
				(response) => {
					if(typeof response.data.merchant_name != 'undefined'){

						this.$cookie.set("merchant_name",		response.data.merchant_name,		{"SameSite": "None", "Secure": ""});
						this.$cookie.set("merchant_number",		response.data.merchant_number,		{"SameSite": "None", "Secure": ""});
						this.$cookie.set("merchant_status",		response.data.merchant_status,		{"SameSite": "None", "Secure": ""});
						this.$cookie.set("merchant_cid",		response.data.merchant_cid,			{"SameSite": "None", "Secure": ""});
						this.$cookie.set("remit_dt",			response.data.remit_dt,				{"SameSite": "None", "Secure": ""});
						this.$cookie.set("paylink",				response.data.paylink,				{"SameSite": "None", "Secure": ""});
						this.$cookie.set("shopify",				response.data.shopify,				{"SameSite": "None", "Secure": ""});
						this.$cookie.set('pb_type',				response.data.merchant_pb_type,		{"SameSite": "None", "Secure": ""});
						this.$cookie.set('curremit',			response.data.merchant_curremit,	{"SameSite": "None", "Secure": ""});
						this.$cookie.set('cid',					response.data.merchant_cid,			{"SameSite": "None", "Secure": ""});
						this.$cookie.set('rep_format',			response.data.perm.user.rep_format,	{"SameSite": "None", "Secure": ""});
						this.$cookie.set('status',				response.data.merchant_status,		{"SameSite": "None", "Secure": ""});
						this.$cookie.set('podmanager_ativo',	response.data.podmanager_ativo,		{"SameSite": "None", "Secure": ""});
						this.$cookie.set('remit_tp',			(response.data.merchant_remit_tp == null ? ''	: response.data.merchant_remit_tp), {"SameSite": "None", "Secure": ""});
						this.$cookie.set('gateway',				(response.data.gateway			== null ? ''	: response.data.gateway),		{"SameSite": "None", "Secure": ""});
						this.$cookie.set('payok',				(response.data.payok			== null ? ''	: response.data.payok),			{"SameSite": "None", "Secure": ""});
						this.$cookie.set('textrecurcc',			(response.data.textrecurcc		== null ? 'N'	: response.data.textrecurcc),	{"SameSite": "None", "Secure": ""});
						this.$cookie.set('autorecurring',		(response.data.autorecurring	== null ? 0 : response.data.autorecurring),		{"SameSite": "None", "Secure": ""});
						this.$cookie.set('recurinst',			(response.data.recurinst		== null ? 0 : response.data.recurinst),			{"SameSite": "None", "Secure": ""});
						this.$cookie.set('maxinst',				(response.data.maxinst			== null ? 0 : response.data.maxinst),			{"SameSite": "None", "Secure": ""});
						this.$cookie.set('payout_ativo',		(response.data.payout_ativo		== null ? 0 : response.data.payout_ativo),		{"SameSite": "None", "Secure": ""});
						this.$cookie.set('vencplink',			(response.data.vencplink		== null ? 0 : response.data.vencplink),			{"SameSite": "None", "Secure": ""});
						this.$cookie.set('fx_rate_assured',		(response.data.fx_rate_assured	== null ? 0 : response.data.fx_rate_assured),	{"SameSite": "None", "Secure": ""});
						this.$cookie.set('payment_curremit',	(response.data.payment_curremit	== null ? '' : response.data.payment_curremit),	{"SameSite": "None", "Secure": ""});
						this.$cookie.set('payment_balance_currency', (response.data.payment_balance_currency == null ? '' : response.data.payment_balance_currency), {"SameSite": "None", "Secure": ""});

						if(!this.$locale.current() || this.$cookie.get("language") != this.$locale.current()){
							this.$locale.change(this.$cookie.get("language"));
						}

						// Reseta as permissões do usuário
						this.perm = response.data.perm;
						localStorage.setItem('perm',					JSON.stringify(response.data.perm));
						localStorage.setItem('pagstream_by_sku',		response.data.pagstream_by_sku);
						localStorage.setItem('pagstream_customer_area', response.data.customerarea);
						localStorage.setItem('distribution_center',		response.data.distribution_center);
						localStorage.setItem('fx_rate_fix',				response.data.fx_rate_fix);
						localStorage.setItem('reserve_type',			response.data.reserve_type);
						localStorage.setItem('refundadicional',			response.data.refundadicional);
						localStorage.setItem('refund_by',				response.data.refund_by);
						localStorage.setItem('payment_ativo',			response.data.payment_ativo);
						localStorage.setItem('pix_automatico',			response.data.pix_automatico);

						this.loadingInformation = true;
					}
				}
			)
			.catch(
				(error) => {
					this.$helper.callback_error(error);
				}
			);

	},

	components: {
		'menudash': MenuDash
	}
}

</script>